// import router from '../../router'
import {
  NSIPS_RELATION_SITUATIONS_SEARCH, NSIPS_RELATION_SITUATIONS_SEARCH_SUCCESS, NSIPS_RELATION_SITUATIONS_SEARCH_FAILURE,
  NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE, NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_SUCCESS, NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_FAILURE,
  NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE, NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_SUCCESS, NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_FAILURE,
  NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE, NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_SUCCESS, NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_FAILURE

} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    ns_prescriptions: null,
    clinics: null,
    doctors: null,
    Notify: null,
    patient_relation_situations_next_page: null,
    patient_relation_situations_current_page: null
  },
  getters: {
    patient_relation_situations: state => {
      return state.ns_prescriptions
    },
    patient_relation_situation_clinics: state => {
      return state.clinics
    },
    patient_relation_situation_doctors: state => {
      return state.doctors
    },
    /** 通知 */
    Notify: state => {
      return state.Notify
    },
    /** ページ送り **/
    patient_relation_situations_next_page: state => {
      return state.patient_relation_situations_next_page
    },
    patient_relation_situations_current_page: state => {
      return state.patient_relation_situations_current_page
    }
  },
  actions: {
    [NSIPS_RELATION_SITUATIONS_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/relation_situations'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      if (params.url) {
        url = params.url
      }
      dispatch('apiGet', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_RELATION_SITUATIONS_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_RELATION_SITUATIONS_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE] ({dispatch, state, commit}, params) {
      var url = '/nsips/relation_situations/patient_remove'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE] ({dispatch, state, commit}, params) {
      var url = '/nsips/relation_situations/clinic_remove'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_FAILURE, {data: res.data, callback: callback})
          } else {
            console.log(res.data)
            commit(NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE] ({dispatch, state, commit}, params) {
      var url = '/nsips/relation_situations/doctor_remove'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [NSIPS_RELATION_SITUATIONS_SEARCH_FAILURE] (state, data) {
      console.log('NSIPS_RELATION_SITUATIONS_SEARCH')
      if (data.callback) {
        data.callback()
      }
    },
    [NSIPS_RELATION_SITUATIONS_SEARCH_SUCCESS] (state, params) {
      console.log('NSIPS_RELATION_SITUATIONS_SEARCH_SUCCESS')
      if (params.data.meta && params.data.meta['current-page'] && params.data.meta['current-page'] > 1) {
        state.ns_prescriptions = state.ns_prescriptions.concat(params.data.data)
        state.patient_relation_situations_current_page = params.data.meta['current-page']
      } else {
        state.ns_prescriptions = params.data.data
        state.patient_relation_situations_current_page = 1
      }
      if (params.data.links && params.data.links['next']) {
        state.patient_relation_situations_next_page = params.data.links['next']
      } else {
        state.patient_relation_situations_next_page = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_FAILURE] (state, data) {
      console.log('NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_FAILURE')
      // 通知
      state.Notify = {
        danger: true,
        message_i18n: 'nsips.relation_remove.failure'
      }
      setTimeout(() => {
        state.Notify = null
      }, constant.notifyShowTime.normal)
    },
    [NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_SUCCESS] (state, params) {
      console.log('NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_SUCCESS')
      if (params.callback) {
        params.callback()
      }
      // 通知
      state.Notify = {
        success: true,
        message_i18n: 'nsips.relation_remove.success'
      }
      setTimeout(() => {
        state.Notify = null
      }, constant.notifyShowTime.normal)
    },
    [NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_FAILURE] (state, data) {
      console.log('NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_FAILURE')
      if (data.callback) {
        data.callback()
      }
      // 通知
      state.Notify = {
        danger: true,
        message_i18n: 'nsips.relation_remove.failure'
      }
      setTimeout(() => {
        state.Notify = null
      }, constant.notifyShowTime.normal)
    },
    [NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_SUCCESS] (state, params) {
      console.log('NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_SUCCESS')
      if (params.callback) {
        params.callback()
      }
      // 通知
      state.Notify = {
        success: true,
        message_i18n: 'nsips.relation_remove.success'
      }
      setTimeout(() => {
        state.Notify = null
      }, constant.notifyShowTime.normal)
    },
    [NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_FAILURE] (state, data) {
      console.log('NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_FAILURE')
      if (data.callback) {
        data.callback()
      }
      // 通知
      state.Notify = {
        danger: true,
        message_i18n: 'nsips.relation_remove.failure'
      }
      setTimeout(() => {
        state.Notify = null
      }, constant.notifyShowTime.normal)
    },
    [NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_SUCCESS] (state, params) {
      console.log('NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_SUCCESS')
      if (params.callback) {
        params.callback()
      }
      // 通知
      state.Notify = {
        success: true,
        message_i18n: 'nsips.relation_remove.success'
      }
      setTimeout(() => {
        state.Notify = null
      }, constant.notifyShowTime.normal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/nsips-relation-situations-list.js